<!--
 * @Description: 水费缴纳条目组件
--> 

<template>
  <div
    class="user-item"
    :style="{
      background:ParentPage==='FeePay'?'rgba(255,255,255,1)':''
    }"
    >
    <div class="item-title">
      <div class="title-wrapper">
        <div class="title-lalel" style="font-size:14px;font-weight:400;">用户号：</div>
        <div class="title-value">{{item.yhh}}</div>
      </div>
      <div v-if="ParentPage!=='FeePay'" class="title-btn">
        <van-button plain type="info" size="small" color="rgba(37,138,55,1)">立即绑定</van-button>
      </div>
    </div>
    <div class="item-info">
      <div class="info-lalel">用户名称：</div>
      <div class="info-value">{{item.yhmc}}</div>
    </div>
    <div class="item-info">
      <div class="info-lalel">用水地址：</div>
      <div class="info-value">{{item.ysdz}}</div>
    </div>
    <van-divider />
    <van-row style="font-size:14px;">
      <van-col span="12">
        到期欠费：{{item.dqqf}} 元
      </van-col>
      <van-col span="12">
        违约金：{{item.wyj}} 元
      </van-col>
    </van-row>
    <div v-if="item.hjje&&item.hjje!=='0'" class="item-title item-fee">
      <div class="title-wrapper">
        <div class="title-lalel">合计金额：</div>
        <div class="title-value">
          <span class="fee-color">{{item.hjje}}</span>&nbsp;元
        </div>
      </div>
      <div class="title-btn">
        <van-button @click="rightNowPay(item)" size="small" type="info" class="search-btn">
          立即缴纳
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeePayItem',
  components: {
  },
  props: {
    ParentPage: String,
    item: Object
  },
  data() {
    return {
    }
  },
  methods: {
    rightNowPay(item){
      location.href = item.wechaturl
    }
  },
}
</script>

<style lang="less" scoped>
.user-item{
  background:rgba(240,246,241,1);
  border-radius:4px;
  padding: 16px 13px;
  .item-title{
    display: flex;
    justify-content: space-between;
    .title-wrapper{
      width: calc(~"100% - 85px");
      display: flex;
      justify-content: space-between;
      .title-label{
        width: 80px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(33,33,33,1);
      }
      .title-value{
        width: calc(~"100% - 80px");
        font-size:14px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(33,33,33,1);
        .fee-color{
          font-size:24px;
          font-weight:Semibold;
          color:#FF0000
        }
      }
    }
    .title-btn{
      width: 85px;
      text-align: right;
      height:30px;
      border-radius:3px;
    }
  }
  .item-info{
    display: flex;
    justify-content: space-between;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(33,33,33,1);
    .info-label{
      width: 80px;
    }
    .info-value{
      width: calc(~"100% - 80px");
    }
  }
  .item-fee{
    // margin-top: 21px;
    // border-top: 1px solid #cccccc;
    height: 62.5px;
    line-height:62.5px;
  }
}
</style>